import { Space } from "antd";

// Estilos compartidos SOLO dentro de Financiero > Ingresos PO (módulo nuevo).
// No se importan ni se usan en ningún componente del módulo viejo.

export const cardHeaderStyle = {
  background: "#042956",
  color: "#fff",
  borderRadius: "10px 10px 0 0",
  minHeight: 44
};

export const cardStyle = {
  borderRadius: 10,
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  marginBottom: 20
};

export const CardTitle = ({ icon, children }) => (
  <Space size={8}>
    {icon}
    <span style={{ fontWeight: 600, fontSize: 13 }}>{children}</span>
  </Space>
);

export const filterOption = (input, option) =>
  (option?.children ?? "").toString().toLowerCase().includes(input.toLowerCase());
